import Vue from 'vue'
import App from './App'
import router from './router'
import { getCookie, delCookie, DOMAIN, isSuSgpLogin, isTlLogin, fen_to_yuan,
  baiduCount, toMainPage, global, getPdf, toLogin, getFileName, getFileSuffix } from '@/assets/js/until.js'
Vue.prototype.$delCookie = delCookie
Vue.prototype.$getCookie = getCookie
Vue.prototype.$isTlLogin = isTlLogin
Vue.prototype.$isSuSgpLogin = isSuSgpLogin
Vue.prototype.$getPdf = getPdf
import ElementUI from 'element-ui'
import 'styles/element-variables.scss'
import 'styles/reset.css'
import '@/assets/styles/main.scss'
import 'babel-polyfill'
import { getUserInfo, getParameterByName } from "@/assets/js/until.js"
Vue.prototype.$getUserInfo = getUserInfo
Vue.prototype.$getParameterByName = getParameterByName
Vue.use(ElementUI)
import axios from 'axios'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.withCredentials = true //允许携带cookie
Vue.prototype.$axios = axios
import { httpConfig, errorCode, firstLevelList, secondLevelList, checkStatusList,
  detectionStatusList, supplyerMsg, productMsg, sampleMsg, test_program, consumerAge, reportTypeList } from './api/api.js'
Vue.prototype.$httpConfig = httpConfig
Vue.prototype.ERRORCODE = errorCode
Vue.prototype.$firstLevelList = firstLevelList
Vue.prototype.$secondLevelList = secondLevelList
Vue.prototype.$checkStatusList = checkStatusList
Vue.prototype.$detectionStatusList = detectionStatusList
Vue.prototype.$supplyerMsg = supplyerMsg
Vue.prototype.$productMsg = productMsg
Vue.prototype.$sampleMsg = sampleMsg
Vue.prototype.$test_program = test_program
Vue.prototype.$consumerAge = consumerAge
Vue.prototype.$reportTypeList = reportTypeList
Vue.prototype.$toLogin = toLogin
Vue.prototype.$toMainPage = toMainPage
import Qs from 'qs'
Vue.prototype.$qs = Qs
Vue.config.productionTip = false
Vue.prototype.$global = global   //全局变量

console.log(process.env.ENV_CONFIG)
axios.interceptors.request.use(async (config) => {
  let _token
  if (process.env.ENV_CONFIG === 'pro') {
    if (!config.url.includes('api/cola/quality_test/get-csrf-token')) {
      const res = await axios.get(httpConfig.COLA + '/api/cola/quality_test/get-csrf-token/')
      _token = res.data.token
    }
    if (_token) {
      config.headers['X-CSRFToken']=_token
    }
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

axios.interceptors.response.use(res => {
  if (res.data.code === errorCode.NOT_LOGIN) {
    const isTl = getParameterByName('tl_user') ? 'tl' : ''
    window.location.href = toLogin(window.location.href, isTl)
  }
  return res
}, err => {
  console.log(err)
  return Promise.reject(err)
})

Vue.filter('fen_to_yuan', fen_to_yuan)
Vue.filter('getFileName', getFileName)
Vue.filter('getFileSuffix', getFileSuffix)
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js